var $ = require('jquery');
var slick = require('slick-carousel-browserify');

class Carousel {
    constructor(selector, options) {
        this.$element = $(selector);
        this.options = options || {
                dots: true,
                speed: 500
            };

        this.init();
    }

    init() {
        slick(this.$element, this.options);
    }

    destroy() {
        slick(this.$element, 'unslick');
    }
}

module.exports = Carousel;